import { motion } from "framer-motion";
import { Landmark, BedDouble, Baby, TrendingUp } from "lucide-react";

const BENEFITS = [
  { n: "01", icon: Landmark, t: "University-Based Programme", d: "The programme is domiciled within the university, giving students automatic university admission into Ignatius Ajuru University of Education." },
  { n: "02", icon: BedDouble, t: "Conducive Learning Environment", d: "Enjoy a quality academic environment with access to good hostel and accommodation facilities." },
  { n: "03", icon: Baby, t: "Suitable for Young Students", d: "A suitable option for students who are underaged and unable to gain direct admission into university." },
  { n: "04", icon: TrendingUp, t: "For Students With Low or No UTME Score", d: "An excellent pathway for students with low UTME scores or those who did not sit for UTME." },
];

export function StudyBenefits() {
  return (
    <section
      className="relative overflow-hidden py-20 sm:py-28 text-white"
      style={{ background: "radial-gradient(120% 100% at 80% 0%, #16347A, #0A1E4E 55%, #071538)" }}
      data-testid="study-benefits-section"
    >
      <div className="absolute inset-0 paper-grain opacity-40" />
      <div className="container-x relative">
        <div className="max-w-3xl">
          <span className="overline text-[#D4AF37]">Benefits of Studying JUPEB &amp; IJMB</span>
          <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.08]">
            Why Study JUPEB &amp; IJMB at the School of Basic Studies, IAUE
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 gap-5 lg:gap-6">
          {BENEFITS.map((b, i) => (
            <motion.div
              key={b.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 2) * 0.1 }}
              className="group relative rounded-sm border border-[#D4AF37]/25 bg-white/[0.04] p-7 backdrop-blur-sm transition-all hover:-translate-y-1 hover:border-[#D4AF37]/70 hover:bg-white/[0.07]"
            >
              <div className="flex items-start justify-between">
                <div className="flex h-14 w-14 items-center justify-center rounded-sm bg-[#D4AF37] text-[#0A1E4E]">
                  <b.icon size={26} />
                </div>
                <span className="font-mono text-3xl font-bold text-white/10 group-hover:text-[#D4AF37]/30 transition-colors">{b.n}</span>
              </div>
              <h3 className="mt-5 font-serif text-xl font-bold text-white">{b.t}</h3>
              <p className="mt-2 text-blue-100/80 leading-relaxed">{b.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="mt-12 h-1 w-full" style={{ background: "linear-gradient(90deg,#D4AF37,#F5B301,#D4AF37)" }} />
    </section>
  );
}
